module.exports = __webpack_public_path__ + "20250721160708/img/wx_info_show.a0d3d432.png";